import Rating from '@mui/material/Rating'

export function StarRating({ score, fontSize }) {
    var size = 18
    if(fontSize) { size = fontSize }
    return (<Rating style={{ fontSize: {fontSize} }} defaultValue={2.5} value={score} precision={0.5} readOnly />)
}